export default class PatchAdminQrDTO {
  address?: string | null;
  longitude?: number | null;
  latitude?: number | null;
  fee?: number;
  countryId?: number;
}
